import React from 'react';
import {compose} from "redux";
import {withStyles, withWidth} from "@material-ui/core";
import {withTranslation} from "react-i18next";
import CustomSvg from "../../../../theme/CustomElements/CustomSvg";
import AddCameraIcon from "./../../../../images/request/add_camera.svg"
import AddCameraPng from "./../../../../images/request/add_camera.png"

import {
    // FILE_2_MB_SIZE_BYTES,
    // STRING,
    USER_TYPE_ADMIN,
    // USER_TYPE_CLIENT,
    USER_TYPE_SUPER_ADMIN, XS
} from "../../../../constants/constants";
import Dropzone from 'react-dropzone'
import axios from "axios";
import {API_UPDATE_LAST_VIEW_DOCUMENT_BY_TYPE, UPLOAD_REQUEST_DOCUMENT} from "../../../../constants/apiSuffix";
// import UploadingAction from "../../../../theme/UploadingAction";
// import * as applicationActions from "../../../../_actions/application";
import * as applicationAction from "../../../../_actions/application";
import {connect} from "react-redux";
import {REQUEST_UPLOAD_FILE_TOKEN} from "../../../../constants/links";
import {withRouter} from "react-router-dom";
import UploadingAndAlertAction from "../../../../theme/UploadingAndAlertAction";
import PropTypes from "prop-types";

const styles = (theme) => ({
    addDocWrapper: {
        borderLeft: '1px solid rgba(113, 109, 135, 0.25)',
        borderRight: '1px solid rgba(113, 109, 135, 0.25)',
        marginRight: 10,

    },
    btnAddCamera: {
        padding: 5,
        minWidth: 'unset',
        textTransform: 'initial',
        color: '#716d87',
        fontSize: '0.7rem',
        margin: '0 10px',
        width: 120,

        '& .addCamera':{
            textTransform: 'uppercase',
        },
        '& .iconBtnAddCameraWrapper':{
            paddingBottom: 8,
            [theme.breakpoints.down(XS)]: {
                paddingBottom: 0
            }
        },
        '& svg path': {
            fill: '#4040ff'
        },
        // '& .MuiButton-label': {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            '& div': {
                lineHeight: '16px',
                // paddingTop: '8px',
            },

        // },
        '&:hover':{
            background:'#dbedff7d',
            borderRadius: 10,
            '& div':{
                color:'#1c1cff',

            },
        },
    },
    btnSeenRequestAlertWrapper:{
        cursor: 'pointer',
        backgroundColor: '#0000f9',
        color: '#fff',
        padding: '4px 10px',
        borderRadius: 15,
        textTransform: 'uppercase',
        fontWeight: 600,
        width: 'fit-content',
        opacity: 0.85,
        '&:hover':{
            opacity: 1
        }
    },
    btnSeenRequestAlertBlock:{
        display:'flex',
        justifyContent: 'center'
    }
});

class ButtonAddDocument extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            successOpen: false,
            countFiles: 0,
            progress: 0,
            errorOpen: false,
            messageError:"",
            newFilesUploaded: []
        }

        this.onUploadProgress = this.onUploadProgress.bind(this)
    }

    onUploadProgress(event) {
        let progress = Math.round((100 * event.loaded) / event.total)
        this.setState({
            progress
        });
    }

    handleChange(allFiles) {
        const {
            requestId,
            match,
        } = this.props;

        if (allFiles.length > 0) {
            if(allFiles.length > 12){
                this.setState({
                    errorOpen: true,
                    messageError: this.props.t("request.doNotUploadMoreThan12Files")
                }, function (){
                    if (typeof this.props.setAlertError === "function") {
                        this.props.setAlertError(true, this.props.t("request.doNotUploadMoreThan12Files"));
                    }
                })
            }else {
                this.setState({
                    isLoading: true,
                })
                this.props.setNewFilesUploaded([])
                const formData = new FormData();
                allFiles.map((file, index) => {
                    formData.append('documents[' + index + '][documentFile]', file);
                });
                const token = match?.params?.token
                const isUploadFileTokenPage = (match?.path) === REQUEST_UPLOAD_FILE_TOKEN
                const apiUploadFileByToken = "/api/upload_request_document_not_auth/" + token
                let config = {
                    onUploadProgress: this.onUploadProgress
                }
                if (isUploadFileTokenPage) {
                    config = {...config, headers: {"Authorization": ""}}
                }
                axios.post(isUploadFileTokenPage ? apiUploadFileByToken : UPLOAD_REQUEST_DOCUMENT.replace("{id}", requestId), formData, {...config})
                    .then(res => {
                        if (res.status === 200) {
                            this.setState({
                                isLoading: false,
                                countFiles: allFiles.length,
                                successOpen: true,
                                progress: 0,
                            })
                            this.props.setNewFilesUploaded(Array.isArray(res?.data?.newFiles) && res.data.newFiles.length ?
                                res.data.newFiles.map(item => (item ? item.id : "")) : [])
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(() => {
                        this.setState({
                            isLoading: false,
                            progress: 0,
                            errorOpen: true,
                        })
                    })
            }
        }
    }
    actionSeenDocumentAlert = (requestId) =>{
        axios.post(API_UPDATE_LAST_VIEW_DOCUMENT_BY_TYPE.replace("{id}", requestId))
            .then(response => {
                if (response.status === 200) {
                    this.props.removeValueToRequestDocumentManagerNotSeenRedux(requestId)
                } else {
                    throw new Error();
                }
            })
            .catch(err => {
            })
    }
    render() {
        const { classes, t, requestId,groupBaseUser, requestDocumentManagerNotSeen, width} = this.props;
        const {
            isLoading,
            errorOpen,
            successOpen,
            countFiles,
            newFilesUploaded
        } = this.state;

        return (
            <div className={`${classes.addDocWrapper} addDocWrapper1`}>
                {/*{isLoading && <UploadingAction progress={this.state.progress}/>}*/}
                <UploadingAndAlertAction isLoading={isLoading}
                                 alertType={successOpen ? "success" : (errorOpen ? "error" : "")}
                                 onClose={() => {
                                     this.setState({
                                         successOpen: false,
                                         errorOpen: false,
                                         messageError: ""
                                     }, function () {
                                         if (typeof this.props.loadingRequest === "function") {
                                             this.props.loadingRequest(newFilesUploaded);
                                         }
                                     })
                                 }}
                                 message={successOpen ?
                                     t('request.list.clientMessageUploadDocument', {
                                         "count": countFiles,
                                         "id": requestId
                                     }) : (this.state.messageError ?? "")}
                />
                <Dropzone
                    ref={(fileUpload) => {
                        this.fileUpload = fileUpload;
                    }}
                    // accept={"image/*, video/*"}
                    minSize={0}
                    // maxSize={FILE_2_MB_SIZE_BYTES}
                    maxFiles={12}
                    multiple={true}
                    onDrop={acceptedFiles => this.handleChange(acceptedFiles)}>
                    {({getRootProps, getInputProps}) => {
                        return (<section>
                            <div {...getRootProps()} className={"dropAvatar"}>
                                <input {...getInputProps()} />
                                <div
                                    className={classes.btnAddCamera}
                                    // onClick={(e) => this.fileUpload.open()}
                                >
                                    <div className={"iconBtnAddCameraWrapper"}>
                                        {width === XS ? <img alt="" src={AddCameraPng}/> :
                                            <CustomSvg
                                                svgProps={{
                                                    src: AddCameraIcon
                                                }}
                                            />}
                                    </div>
                                    <div className="addCamera labelButtonWrapper">{t("request.list.add_camera")}</div>
                                </div>
                            </div>
                        </section>)
                    }}
                </Dropzone>
                {[USER_TYPE_ADMIN, USER_TYPE_SUPER_ADMIN].includes(groupBaseUser) && Array.isArray(requestDocumentManagerNotSeen) && requestDocumentManagerNotSeen.includes(requestId)  ?
                    <div className={classes.btnSeenRequestAlertBlock}><div className={classes.btnSeenRequestAlertWrapper} onClick={() => this.actionSeenDocumentAlert(requestId)}>{t("request.list.seenDocumentManagerUpdated")}</div>
                    </div> : ""}
            </div>
        );
    }
}


ButtonAddDocument.defaultProps = {
    setNewFilesUploaded: () => {},
    loadingRequest: () => {}
}

ButtonAddDocument.propTypes = {
    classes: PropTypes.object.isRequired,
    setNewFilesUploaded: PropTypes.func,
    loadingRequest: PropTypes.func
}


const mapStateToProps = (state) => {
    return {
        dataUser: state.authReducer.dataUser,
        groupBaseUser: state.authReducer.groupBaseUser,
        requestDocumentManagerNotSeen: state.applicationReducer.requestDocumentManagerNotSeen,
        countPaymentRequestReport:state.applicationReducer.countPaymentRequestReport,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        removeValueToRequestDocumentManagerNotSeenRedux: (value) => dispatch(applicationAction.removeValueToRequestDocumentManagerNotSeenRedux(value)),
    };
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),withStyles(styles), withTranslation(), withRouter, withWidth())(ButtonAddDocument);
